import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
interface FinalCTAProps {
  selectedPlan: 'pro' | 'megapack';
  onSelectPlan: (plan: 'pro' | 'megapack') => void;
}
export function FinalCTA({
  selectedPlan,
  onSelectPlan
}: FinalCTAProps) {
  const plans = [{
    id: 'pro',
    name: 'Kit Pro',
    desc: '6 tomos + 3 bonos',
    price: '$19.990',
    url: 'https://checkout.solucionesya.shop/cart/48864550977784:1'
  }, {
    id: 'megapack',
    name: 'Megapack Pro',
    desc: '8 tomos + 3 bonos',
    price: '$29.990',
    badge: '⭐ Más elegida',
    url: 'https://checkout.solucionesya.shop/cart/48864554877176:1'
  }];
  const currentPlan = plans.find(p => p.id === selectedPlan) || plans[1];
  return <section className="bg-gradient-to-br from-navy to-[#0d2e1a] py-12 sm:py-20 px-5 text-center" data-id="element-81">
      <div className="max-w-3xl mx-auto" data-id="element-82">
        <h2 className="font-display text-2xl sm:text-4xl md:text-5xl lg:text-6xl text-white mb-3 sm:mb-4 leading-tight" data-id="element-83">
          Las palabras correctas
          <br data-id="element-84" />
          en el momento correcto
          <br data-id="element-85" />
          <span className="text-gold-light" data-id="element-86">cambian todo.</span>
        </h2>
        <p className="text-white/70 text-sm sm:text-lg max-w-xl mx-auto mb-8 sm:mb-12 leading-relaxed" data-id="element-87">
          Estudiaste años para saber lo que sabés. Ahora también sabés cómo
          decirlo.
        </p>

        <div className="bg-white rounded-2xl p-5 sm:p-8 shadow-2xl text-left max-w-2xl mx-auto mb-8" data-id="element-88">
          <div className="mb-5" data-id="element-89">
            <CountdownTimer variant="light" data-id="element-90" />
          </div>
          <div className="flex flex-col gap-3 sm:gap-4 mb-6" data-id="element-91">
            {plans.map(plan => {
            const isSelected = selectedPlan === plan.id;
            return <div key={plan.id} onClick={() => onSelectPlan(plan.id as 'pro' | 'megapack')} className={`flex items-center justify-between p-4 sm:p-5 rounded-xl border-2 cursor-pointer transition-all ${isSelected ? 'border-gold bg-gold/5 shadow-sm' : 'border-gray-100 hover:border-gray-300 bg-white'}`} data-id="element-92">
                  <div className="flex items-center gap-3 sm:gap-4" data-id="element-93">
                    <div className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${isSelected ? 'border-gold' : 'border-gray-300'}`} data-id="element-94">
                      {isSelected && <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-gold rounded-full" data-id="element-95" />}
                    </div>
                    <div data-id="element-96">
                      <div className="font-bold text-navy text-sm sm:text-lg flex items-center flex-wrap gap-2" data-id="element-97">
                        {plan.name}
                        {plan.badge && <span className="text-[9px] sm:text-[10px] bg-gold text-navy px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-98">
                            {plan.badge}
                          </span>}
                      </div>
                      <div className="text-[11px] sm:text-sm text-gray mt-0.5" data-id="element-99">
                        {plan.desc}
                      </div>
                    </div>
                  </div>
                  <div className="text-right pl-2" data-id="element-100">
                    <div className="font-display font-bold text-lg sm:text-2xl text-navy leading-none" data-id="element-101">
                      {plan.price}
                    </div>
                  </div>
                </div>;
          })}
          </div>

          <motion.a href={currentPlan.url} whileHover={{
          y: -2,
          boxShadow: '0 10px 32px rgba(201,149,42,0.45)'
        }} whileTap={{
          scale: 0.96
        }} className="block w-full text-center bg-gradient-to-br from-gold to-gold-light text-navy font-bold text-sm sm:text-lg py-4 rounded-xl shadow-[0_6px_24px_rgba(201,149,42,0.35)] transition-all" data-id="element-102">
            💥 COMPRAR {currentPlan.name.toUpperCase()} · {currentPlan.price}
          </motion.a>
        </div>

        <div className="flex flex-wrap justify-center gap-4 sm:gap-7 text-white/60 text-[11px] sm:text-sm" data-id="element-103">
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-104">
            <span className="text-green-light text-sm sm:text-base" data-id="element-105">✓</span>{' '}
            Garantía 7 días
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-106">
            <span className="text-green-light text-sm sm:text-base" data-id="element-107">✓</span>{' '}
            Acceso inmediato
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-108">
            <span className="text-green-light text-sm sm:text-base" data-id="element-109">✓</span>{' '}
            Pago seguro
          </div>
        </div>
      </div>
    </section>;
}